<template>
    <div class="com">
        <div class="com-name">
            <h3 class="title">请填写以下信息投诉</h3>
            <div class="desc">非常抱歉给您带来不便，我们重视每一位用户的体验，请填写信息帮助我们明确问题。</div>
        </div>
        <div class="input">
            <div class="input-title"> 投诉描述</div>
            <van-field v-model="message"
                       label=""
                       type="textarea"
                       maxlength="100"
                       placeholder="请填写10字以上的投诉原因以便我们核实情况"
                       show-word-limit />

        </div>
        <div class="line"></div>
        <div class="img">
            <div class="img-title">
                <div class="title-left"><span class="name">图片证据</span><span class="n">(选填)</span></div>
                <div class="title-right">{{n}}/4</div>
            </div>
            <div class="tips">请上传与本次投诉相关的图片证据</div>
            <div class="up-img">
                <van-uploader v-model="fileList"
                              :after-read="afterRead"
                              multiple
                              :max-count="4" />
            </div>
        </div>
        <div class="line"></div>
        <div class="phone">
            <span class="num">本人手机号</span><span class="tips">(必填)</span>
            <van-field v-model="value"
                       class="number"
                       label=""
                       placeholder="请输入手机号" />
        </div>
        <div class="btn">
            <div class="btn-main"
                 @click="submit">提交</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'home',
    components: {
    },
    async created () {
    },
    data () {
        return {
            starred: '',
            message: '',
            fileList: [],
            value: '',
            n: 0
        }
    },
    mounted () {
        // 这里是测试
        console.log('111');
    },
    methods: {
        submit () {
            if (this.message.length < 10) {
                this.$notify({ type: 'warning', message: '投诉描述不得少于10个字!' });
                return false;
            }
            if (this.value === '') {
                this.$notify({ type: 'warning', message: '请填写手机号!' });
                return false;
            }

            var reg_tel = /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/;    //11位手机号码正则
            if (!reg_tel.test(this.value)) {
                this.$notify({ type: 'warning', message: '请填写正确的手机号！' });
                return false;
            }
            this.$router.push({
                path: '/comSuccess'
            })
        },
        afterRead (file) {
            // 此时可以自行将文件上传至服务器
            console.log(this.fileList.length, 99);
            this.n = this.fileList.length;
            console.log(file);
        },

    }
};
</script>
<style scoped >
.com {
    text-align: left;
    line-height: 1.5;
}
.com .com-name {
    background-color: #f8f8f8;
}
.com .com-name .title {
    padding-top: 28px;
    padding-left: 18px;
    font-size: 24px;
}

.com .com-name .desc {
    color: #7b7b7b;
    font-size: 14px;
    padding: 16px 18px 48px 18px;
}
.input {
    width: 100%;
    height: 162px;
    background: #fff;
    padding: 16px 18px 16px 18px;
}
.input .input-title {
    color: #1b1b1b;
    font-size: 16px;
    font-weight: 600;
}
.input >>> .van-cell {
    padding: 0;
    padding-top: 12px;
}
.input >>> .van-field__control {
    height: 80px;
}
.line {
    width: 100%;
    height: 10px;
    background-color: #f8f8f8;
}
.img {
    padding: 16px 18px;
}
.img .img-title {
    display: flex;
}
.img .title-left {
}
.img .title-left .name {
    color: #1b1b1b;
    font-size: 16px;
    font-weight: 600;
}
.img .title-left .n {
    padding-left: 12px;
    font-size: 16px;
    color: #b7b7b7;
}
.img .title-right {
    flex: 1;
    font-size: 12px;
    text-align: right;
    color: #b7b7b7;
}
.img .tips {
    padding-top: 12px;
    padding-bottom: 20px;
    color: #b7b7b7;
    font-size: 14px;
}
.up-img {
    padding-bottom: 8px;
}

.up-img >>> .van-uploader__preview {
    margin: 0 5px 0 0;
    height: 80px;
    overflow: hidden;
}
.up-img >>> .van-uploader__preview:last-child {
    margin-right: 0;
}
.phone {
    display: flex;
    align-items: center;
    width: 100%;
    height: 56px;
    line-height: 56px;
}
.phone .num {
    padding-left: 18px;
    color: #1b1b1b;
    font-size: 16px;
    font-weight: 600;
}
.phone .tips {
    color: #b7b7b7;
    font-size: 16px;
    padding-left: 12px;
    padding-right: 16px;
}
.phone .number {
    width: 176px;
    padding: 0;
    /* padding-left: 28px; */
    color: #b7b7b7;
    font-size: 16px;
}
.btn {
    padding: 24px 18px;
}
.btn .btn-main {
    width: 100%;
    height: 58px;
    line-height: 58px;
    text-align: center;
    border-radius: 8px;
    background: #64ad78;
    font-weight: 700;
    font-size: 18px;
    color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/complaint.vue